import { MapPin } from "lucide-react";
import { SITE } from "@/data/site";

export const ContactMap = () => (
    <a
        data-testid="google-map-link"
        href={SITE.mapsLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Apri la sede TECNO-LAV su Google Maps"
        className="group relative mt-8 block border border-white/10"
    >
        <iframe
            data-testid="google-map-embed"
            title="Mappa TECNO-LAV — Via per Airuno 19, Brivio (LC)"
            src={SITE.mapsEmbed}
            loading="lazy"
            tabIndex={-1}
            className="pointer-events-none h-64 w-full grayscale-[35%] contrast-[1.05] transition-[filter] duration-300 group-hover:grayscale-0"
            referrerPolicy="no-referrer-when-downgrade"
        />
        <span className="absolute bottom-3 right-3 flex items-center gap-2 bg-tl-black/90 px-3 py-2 font-mono-tl text-[10px] uppercase tracking-[0.25em] text-white transition-colors group-hover:bg-tl-orange group-hover:text-tl-black">
            <MapPin size={12} /> Apri su Google Maps
        </span>
    </a>
);
